export default "__VITE_ASSET__aiIkKQuX__"